import { Grid } from "@mui/material";
import FormInput from "../../../query-builder/hooks-form-querybuilder/form-input.component";
import { useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import { FormSelect } from "../../../query-builder/hooks-form-querybuilder/form-select.component";
import { FormAutoCompleteMultiSelectDynamic } from "../../../query-builder/hooks-form-querybuilder/form-autocomplete-multi-select.dynamic.component";
import { projectsApiKeyStore } from "../../../../api/projects-api-key-store";
import { FormAutoCompleteSelectDynamic } from "../../../query-builder/hooks-form-querybuilder/form-autocomplete-select.dynamic.component";
import FormDateField, { DateFormat } from "../../../../components/hook-form/form-date.field.component";

const endPriorPricingListOption = [
    {
        value: 'Yes',
        label: 'Yes',
        isDefault: false,
    },
    {
        value: 'No',
        label: 'No',
        isDefault: false,
    },
];

const pricingListAppliesToOptionRES = [
    {
        value: 'AllNewStarts',
        label: 'All New Starts',
        isDefault: false,
    },
    {
        value: 'AllLots',
        label: 'All Lots',
        isDefault: false,
    },
    {
        value: 'AllNewTH',
        label: 'All New TH',
        isDefault: false,
    },
    {
        value: 'AllNewSFR',
        label: 'All New SFR',
        isDefault: false,
    },
];

const pricingListAppliesToOptionCOM = [
    {
        value: 'AllNewStarts',
        label: 'All New Starts',
        isDefault: false,
    },
    {
        value: 'AllLots',
        label: 'All Lots',
        isDefault: false,
    },
    {
        value: 'AllNewCM',
        label: 'All New Commercial (CM)',
        isDefault: false,
    },
];

interface AddNewPriceDialog {
    projectID: any;
    projectType: any;
    isEdit: boolean;
    isLoading: boolean;
    setEnablePrice: (value: boolean) => void;
}

export const AddNewPriceFields = ({ projectID, projectType, isEdit, isLoading, setEnablePrice }: AddNewPriceDialog) => {

    const { setValue, getValues } = useFormContext();
    const [endPriorValue, setEndPriorValue] = useState<boolean>(false);
    const [disabledEndDate, setDisabledEndDate] = useState<boolean>(isEdit ? true : false);

    useEffect(() => {
        setEnablePrice(getValues('endPriorPricingList') == 'Yes' ? true : false);
        setEndPriorValue(getValues('endPriorPricingList') == 'Yes' ? true : false);
    }, [])

    const handleStartDate = (date: any) => {
        setDisabledEndDate(!!date);
        setValue('pricingEndDate', '');
    };

    const handleEndPriorPricingChange = (value: any) => {
        setEndPriorValue(value == 'Yes' ? true : false);
        setEnablePrice(value == 'Yes' ? true : false);
    }


    return (
        <Grid container spacing={1}>
            <Grid item lg={3} sm={3} xl={3} xs={3}>
                <FormInput name="pricingListName" label="Pricing List Name" isParentLoading={isLoading} />
            </Grid>
            <Grid item xl={2} lg={2} sm={2} xs={2}>
                <FormDateField
                    label='Pricing Start Date'
                    name="pricingStartDate"
                    onChange={handleStartDate}
                    format={DateFormat.SIMPLE_DATE}
                    isParentLoading={isLoading}
                />
            </Grid>
            <Grid item xl={2} lg={2} sm={2} xs={2}>
                <FormDateField
                    label="Pricing End Date"
                    name="pricingEndDate"
                    disabled={!disabledEndDate}
                    format={DateFormat.SIMPLE_DATE}
                    dateLimits={{
                        minDateEnabled: true,
                        minDateValue: 'pricingStartDate',
                    }}
                    isParentLoading={isLoading}
                />
            </Grid>
            {!isEdit && (
                <>
                    <Grid item xl={2} lg={2} sm={2} xs={2}>
                        <FormSelect
                            label="End Prior Pricing List?"
                            name="endPriorPricingList"
                            onChange={handleEndPriorPricingChange}
                            options={endPriorPricingListOption} />
                    </Grid>
                    {endPriorValue && (
                        <Grid item xl={3} lg={3} sm={3} xs={3}>
                            <FormAutoCompleteSelectDynamic
                                name="priceListToEnd"
                                label="Select Price List To End"
                                getQueryKeyConfig={() => projectsApiKeyStore.getProjectPricingListByPorject(projectID)}
                                optionsValueKey="pricingListID"
                                optionsLabelKey="pricingListName"
                            />
                        </Grid>
                    )}</>
            )}
            <Grid item xl={3} lg={3} sm={3} xs={3}>
                <FormSelect
                    label="Pricing List Applies To"
                    name="pricingListAppliesToLotType"
                    options={projectType === "RES" ? pricingListAppliesToOptionRES : pricingListAppliesToOptionCOM} />
            </Grid>
        </Grid>
    );
}